import { get } from '@/api/request'

export default {

  loadSubscriptionTypes: (success, failure) => get(
    '/api/subscription-types',
    success, failure
  ),
}